import {Injectable, signal} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Params} from '@angular/router';
import {CommonTableData} from '@lib-ui/common-table/models/common-table-data.class';
import {MessageService} from '@lib-services/message.service';
import {IFile} from '@lib-typing/file.interface';
import {FileService} from '@lib-services/file.service';
import {ICommonTableConfig, ICommonTableService} from '@lib-ui/common-table/models/common-table.interface';
import {setDayRange} from '../../../../../../libs/utils/date-format';

@Injectable({
    providedIn: 'root',
})
export class FileTableService implements ICommonTableService<IFile> {
    public tableData$: BehaviorSubject<CommonTableData<IFile>> = new BehaviorSubject<CommonTableData<IFile>>(new CommonTableData());
    defaultFilterParams = {
        sortBy: 'createdAt:DESC',
    };
    private readonly commonTableData = new CommonTableData();
    loading = signal<boolean>(false);

    constructor(private fileService: FileService, private messageService: MessageService) {}

    updateData(config: ICommonTableConfig): void {
        this.loading.set(true);
        this.fileService
            .getList(this.createSearchParams(config))
            .subscribe({
                next: response => {
                    this.tableData$.next(new CommonTableData(response));
                },
                error: () => this.messageService.errorMessage('Ошибка загрузки списка файлов'),
            })
            .add(() => this.loading.set(false));
    }

    createSearchParams(config: ICommonTableConfig): Params {
        this.commonTableData.data.length = 0;
        const { pageIndex, itemsPerPage } = config.paginatorConfig;
        const { filters } = config;

        let searchParams: Params = {
            ...this.defaultFilterParams,
            limit: itemsPerPage.toString(),
        };

        if (pageIndex) {
            searchParams = {
                ...searchParams,
                page: pageIndex.toString(),
            };
        }

        if (filters) {
            Object.entries(filters).forEach(([key, value]) => {
                if (value) {
                    let filterValue;

                    switch (key) {
                    case 'createdAt':
                        filterValue = setDayRange(value as string);
                        break;
                    default:
                        filterValue = `${value}`;
                    }
                    searchParams = {
                        ...searchParams,
                        [`filter.${key}`]: filterValue,
                    };
                }
            });
        }

        return searchParams;
    }

}
